package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.CSSColorValue

@Composable
fun StyledSvg(
    tint: CSSColorValue,
    url: String,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(tint)
                .styleModifier {
                    property("mask-image", "url(${url})")
                    property("mask-size", "contain")
                    property("mask-repeat", "no-repeat")
                    property("mask-position", "center")
                    property("-webkit-mask-image", "url(${url})")
                    property("-webkit-mask-size", "contain")
                    property("-webkit-mask-repeat", "no-repeat")
                    property("-webkit-mask-position", "center")
                }
        )
    }
}
